import { ConnectedPosition } from '@angular/cdk/overlay';

const connectedPositionTopLeft: ConnectedPosition = {
  originX: 'start',
  originY: 'top',
  overlayX: 'start',
  overlayY: 'bottom',
};

const connectedPositionTopRight: ConnectedPosition = {
  originX: 'end',
  originY: 'top',
  overlayX: 'end',
  overlayY: 'bottom',
};

const connectedPositionBottomRight: ConnectedPosition = {
  originX: 'end',
  originY: 'bottom',
  overlayX: 'end',
  overlayY: 'top',
};

const connectedPositionBottomLeft: ConnectedPosition = {
  originX: 'start',
  originY: 'bottom',
  overlayX: 'start',
  overlayY: 'top',
};

export const connectedPositionsBottomLeftPriority: ConnectedPosition[] = [
  connectedPositionBottomLeft,
  connectedPositionBottomRight,
  connectedPositionTopLeft,
  connectedPositionTopRight,
];

export const connectedPositionsBottomRightPriority: ConnectedPosition[] = [
  connectedPositionBottomRight,
  connectedPositionBottomLeft,
  connectedPositionTopRight,
  connectedPositionTopLeft,
];
